import axios from './axiosInstance';
import { APIUserGroupDetailed } from '../../types';

interface SportParkParams {
  sport: string;
  parkId: string;
}

interface CreateUserGroupParams extends SportParkParams {
  name: string;
  description?: string;
}

interface GetUserGroupParams extends SportParkParams {
  userGroupId: string;
}

interface UpdateUserGroupParams extends SportParkParams {
  userGroupId: string;
  name?: string;
  description?: string;
}

interface DeleteUserGroupParams extends SportParkParams {
  userGroupId: string;
}

interface UpdateUserGroupMembersParams extends SportParkParams {
  userGroupId: string;
  members: { userId: string; action: string }[];
}

interface GetUserGroupAssignmentsParams extends SportParkParams {
  principalType?: string;
  principalId?: string;
  userGroupId?: string;
  expand?: string;
  limit?: number;
  pageCursor?: string;
}

const createUserGroup = ({ sport, parkId, name, description }: CreateUserGroupParams): Promise<APIUserGroupDetailed> => {
  const url = `/${sport}/areas/${parkId}/usergroups`;
  return axios.put(url, {
    name,
    description,
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getUserGroups = ({ sport, parkId }: SportParkParams): Promise<APIUserGroupDetailed[]> => {
  const url = `/${sport}/areas/${parkId}/usergroups`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getUserGroup = ({ sport, parkId, userGroupId }: GetUserGroupParams): Promise<APIUserGroupDetailed> => {
  const url = `/${sport}/areas/${parkId}/usergroups/${userGroupId}`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const updateUserGroup = ({ sport, parkId, userGroupId, name, description }: UpdateUserGroupParams): Promise<APIUserGroupDetailed> => {
  const url = `/${sport}/areas/${parkId}/usergroups/${userGroupId}`;
  const body: Record<string, string> = {};
  if (name !== undefined) {
    body.name = name;
  }
  if (description !== undefined) {
    body.description = description;
  }
  return axios.post(url, body)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const deleteUserGroup = ({ sport, parkId, userGroupId }: DeleteUserGroupParams): Promise<any> => {
  const url = `/${sport}/areas/${parkId}/usergroups/${userGroupId}`;
  return axios.delete(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const updateUserGroupMembers = ({ sport, parkId, userGroupId, members }: UpdateUserGroupMembersParams): Promise<any> => {
  const url = `/${sport}/areas/${parkId}/usergroups/${userGroupId}/members`;
  return axios.post(url, members)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const getUserGroupAssignments = ({ sport, parkId, principalType, principalId, userGroupId, expand, limit, pageCursor }: GetUserGroupAssignmentsParams): Promise<any> => {
  const url = `/${sport}/areas/${parkId}/usergroups/assignments`;
  const params: Record<string, string | number> = {};

  if (principalType) params.principalType = principalType;
  if (principalId) params.principalId = principalId;
  if (userGroupId) params.userGroupId = userGroupId;
  if (expand) params.expand = expand;
  if (limit) params.limit = limit;
  if (pageCursor) params.pageCursor = pageCursor;

  return axios.get(url, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      throw error;
    });
};

const userGroupFunctions = {
  createUserGroup,
  getUserGroups,
  getUserGroup,
  updateUserGroup,
  deleteUserGroup,
  updateUserGroupMembers,
  getUserGroupAssignments,
};

export default userGroupFunctions;
